<footer class="footer-credit" [class.hidden]="isHidden">
    <p class="text-footer">made with <span>❤︎</span> by Lab Pengembangan UIMA 2025</p>
</footer>

<footer>
    <p class="footer-text" [class.hidden]="!isHidden2 ">
        made with <span>❤︎</span> by LabRiset UIMA 2025
    </p>
</footer>